import { Component } from '@angular/core'
import { ApplicationSettings } from '../../../api/models'

@Component({
  selector: 'app-app-settings',
  templateUrl: './app-settings.component.html',
  styleUrl: './app-settings.component.css',
})
export class AppSettingsComponent {
  settings = {} as ApplicationSettings

  watermarkLocationOptions: any
  smtpSecurityOptions: any
  logLevelOptions: any
  multipleSessionOptions: any
  mfaTypeOptions: any
}
